import styled from 'styled-components'

export const QsrHeader = styled.div`
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;

  > div {
    display: flex;
    flex-direction: column;
  }

  .headline {
    font-weight: bold;
    text-align: start;
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
  }

  .headline-details {
    margin-top: 10px;

    .row-item {
      margin: 10px 0;
    }

    .tooltip {
      margin-left: 8px;
    }

    &--treatment {
      margin-top: 30px;
    }
  }

  .row-item {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .qsr-indicator {
    width: auto;
    margin-right: 10px;
  }
`
